import authAxios, { authHeader } from "../data";
import qs from "qs";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/Customers", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchTypes = async () => {
  const response = await authAxios.get("/api/Customers/CustomersTypes", {
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get("/api/Customers/Count", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const save = async (request: any) => {
  const response = await authAxios.post("/api/Customers", request, {
    headers: authHeader(),
  });

  return response.data;
};

const deleteCustomer = async (id: string) => {
  const response = await authAxios.delete("/api/Customers/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const get = async (id: string) => {
  const response = await authAxios.get("/api/Customers/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (id: string, request: any) => {
  const response = await authAxios.put(`/api/Customers/${id}`, request, {
    headers: authHeader(),
  });

  return response.data;
};

const searchByNumber = async (number: number) => {
  const response = await authAxios.get(
    "/api/Customers/ByNumber?Number=" + number,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const fetchCustomerAccounts = async (request: any) => {
  const response = await authAxios.get("/api/CustomersContracts", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const CustomersService = {
  fetchAll,
  fetchCount,
  deleteCustomer,
  save,
  get,
  update,
  fetchCustomerAccounts,
  fetchTypes,
  searchByNumber,
};

export default CustomersService;
